var DappErrorName = /* @__PURE__ */ ((DappErrorName2) => {
  DappErrorName2["DecodeError"] = "Decode Error";
  DappErrorName2["InvalidParams"] = "Invalid Params";
  DappErrorName2["UserRejected"] = "User Rejected";
  DappErrorName2["NotAllowed"] = "Not Allowed";
  return DappErrorName2;
})(DappErrorName || {});
class DappError extends Error {
  constructor(message, name = "Invalid Params", rawError = void 0) {
    super(message);
    if (message === "User Rejected") {
      this.name = message;
    } else {
      this.name = name;
    }
    this.rawError = rawError;
  }
}
function encode(obj, pfx) {
  let k;
  let i;
  let tmp;
  let str = "";
  for (k in obj) {
    if ((tmp = obj[k]) !== void 0) {
      if (Array.isArray(tmp)) {
        for (i = 0; i < tmp.length; i++) {
          str && (str += "&");
          str += `${encodeURIComponent(k)}=${encodeURIComponent(tmp[i])}`;
        }
      } else {
        str && (str += "&");
        str += `${encodeURIComponent(k)}=${encodeURIComponent(tmp)}`;
      }
    }
  }
  return (pfx || "") + str;
}
function toValue(mix) {
  if (!mix)
    return "";
  const str = decodeURIComponent(mix);
  if (str === "false")
    return false;
  if (str === "true")
    return true;
  return +str * 0 === 0 && `${+str}` === str ? +str : str;
}
function decode(str) {
  let tmp;
  let k;
  const out = {};
  const arr = str.split("&");
  while (tmp = arr.shift()) {
    tmp = tmp.split("=");
    k = tmp.shift();
    if (out[k] !== void 0) {
      out[k] = [].concat(out[k], toValue(tmp.shift()));
    } else {
      out[k] = toValue(tmp.shift());
    }
  }
  return out;
}
function parseSearchWith(parser) {
  return (searchStr) => {
    if (searchStr.substring(0, 1) === "?") {
      searchStr = searchStr.substring(1);
    }
    const query = decode(searchStr);
    for (const key in query) {
      const value = query[key];
      if (typeof value === "string") {
        try {
          query[key] = parser(value);
        } catch (err) {
        }
      }
    }
    if (Object.keys(query).length === 0) {
      throw new DappError("Invalid request", DappErrorName.InvalidParams);
    }
    return query;
  };
}
function stringifySearchWith(stringify, parser) {
  function stringifyValue(val) {
    if (typeof val === "object" && val !== null) {
      try {
        return stringify(val);
      } catch (err) {
      }
    } else if (typeof val === "string" && typeof parser === "function") {
      try {
        parser(val);
        return stringify(val);
      } catch (err) {
      }
    }
    return val;
  }
  return (search) => {
    search = { ...search };
    if (search) {
      Object.keys(search).forEach((key) => {
        const val = search[key];
        if (typeof val === "undefined" || val === void 0) {
          delete search[key];
        } else if (Array.isArray(val)) {
          search[key] = val.map(stringifyValue);
        } else {
          search[key] = stringifyValue(val);
        }
      });
    }
    const searchStr = encode(search).toString();
    return searchStr ? `?${searchStr}` : "";
  };
}
const decodeSearch = parseSearchWith(JSON.parse);
const encodeSearch = stringifySearchWith(JSON.stringify, JSON.parse);
function appendBuffer(buffer1, buffer2) {
  const tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
  tmp.set(new Uint8Array(buffer1), 0);
  tmp.set(new Uint8Array(buffer2), buffer1.byteLength);
  return tmp.buffer;
}
function base64URLStringToBuffer(base64URLString) {
  const base64 = base64URLString.replace(/-/g, "+").replace(/_/g, "/");
  const padLength = (4 - base64.length % 4) % 4;
  const padded = base64.padEnd(base64.length + padLength, "=");
  const binary = atob(padded);
  const buffer = new ArrayBuffer(binary.length);
  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return buffer;
}
function bufferToBase64URLString(buffer) {
  const bytes = new Uint8Array(buffer);
  let str = "";
  for (let i = 0; i < bytes.length; i++) {
    const charCode = bytes[i];
    str += String.fromCharCode(charCode);
  }
  const base64String = btoa(str);
  return base64String.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function hexToArrayBuffer(input) {
  const view = new Uint8Array(input.length / 2);
  for (let i = 0; i < input.length; i += 2) {
    view[i / 2] = parseInt(input.substring(i, i + 2), 16);
  }
  return view.buffer;
}
function bufferToHex(buffer) {
  return [...new Uint8Array(buffer)].map((b) => b.toString(16).padStart(2, "0")).join("");
}
function utf8StringToBuffer(value) {
  return new TextEncoder().encode(value);
}
function hexToString(hex) {
  let str = "";
  for (let i = 0; i < hex.length; i += 2)
    str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
  return str;
}
function isStandaloneBrowser() {
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
}
function derToIEEE(sig) {
  const signature = Array.from(
    new Uint8Array(sig),
    (x) => `00${x.toString(16)}`.slice(-2)
  ).join("");
  const rLength = parseInt(signature.substr(6, 2), 16) * 2;
  let r = signature.substr(8, rLength);
  let s = signature.substr(12 + rLength);
  r = r.length > 64 ? r.substr(-64) : r.padStart(64, "0");
  s = s.length > 64 ? s.substr(-64) : s.padStart(64, "0");
  const p1363Sig = `${r}${s}`;
  return new Uint8Array(
    p1363Sig.match(/[\da-f]{2}/gi).map((h) => parseInt(h, 16))
  );
}
var DappRequestType = /* @__PURE__ */ ((DappRequestType2) => {
  DappRequestType2["Auth"] = "Auth";
  DappRequestType2["SignMessage"] = "SignMessage";
  DappRequestType2["SignEvm"] = "SignEvm";
  DappRequestType2["SignCkbTx"] = "SignCkbTx";
  DappRequestType2["SignCotaNFT"] = "SignCotaNFT";
  DappRequestType2["SignNostrEvent"] = "SignNostrEvent";
  DappRequestType2["EncryptNostrMessage"] = "EncryptNostrMessage";
  DappRequestType2["DecryptNostrMessage"] = "DecryptNostrMessage";
  return DappRequestType2;
})(DappRequestType || {});
var DappCommunicationType = /* @__PURE__ */ ((DappCommunicationType2) => {
  DappCommunicationType2["Popup"] = "popup";
  DappCommunicationType2["Redirect"] = "redirect";
  return DappCommunicationType2;
})(DappCommunicationType || {});
class RedirectErrorWithState extends Error {
  constructor(message, state) {
    super(message);
    this.message = message;
    this.state = state;
    this.state = state;
  }
}
const getRedirectResponse = (uri) => {
  const url = new URL(uri || window.location.href);
  const data = url.searchParams.get("_data_");
  if (!data) {
    throw new Error("No data found");
  }
  const res = decodeSearch(data);
  if (res.error != null) {
    throw new RedirectErrorWithState(res.error, res.state);
  }
  return res.data;
};
const internalConfig = {
  joyidAppURL: "https://testnet.joyid.dev"
};
const initConfig$1 = (config) => {
  Object.assign(internalConfig, config);
  return internalConfig;
};
const getConfig$1 = () => internalConfig;
const JOYID_REDIRECT = "joyid-redirect";
const buildJoyIDURL = (request, type, path) => {
  const joyidURL = getConfig$1().joyidAppURL;
  const url = new URL(`${joyidURL}${path}`);
  let redirectTo = request.redirectURL;
  if (type === "redirect") {
    const redirectURL = new URL(redirectTo);
    redirectURL.searchParams.set(JOYID_REDIRECT, "true");
    redirectTo = redirectURL.href;
  }
  url.searchParams.set("type", type);
  const data = encodeSearch({
    ...request,
    redirectURL: redirectTo
  });
  url.searchParams.set("_data_", data);
  return url.href;
};
class GenericError extends Error {
  constructor(error, error_description) {
    super(error_description);
    this.error = error;
    this.error_description = error_description;
    Object.setPrototypeOf(this, GenericError.prototype);
  }
  static fromPayload({
    error,
    error_description
  }) {
    return new GenericError(error, error_description);
  }
}
class TimeoutError extends GenericError {
  constructor() {
    super("timeout", "Timeout");
    Object.setPrototypeOf(this, TimeoutError.prototype);
  }
}
class PopupTimeoutError extends TimeoutError {
  constructor(popup) {
    super();
    this.popup = popup;
    Object.setPrototypeOf(this, PopupTimeoutError.prototype);
  }
}
class PopupCancelledError extends GenericError {
  constructor(popup) {
    super("cancelled", "Popup closed");
    this.popup = popup;
    Object.setPrototypeOf(this, PopupCancelledError.prototype);
  }
}
class PopupNotSupportedError extends GenericError {
  constructor(popup) {
    super(
      "NotSupported",
      "Popup window is blocked by browser. see: https://docs.joy.id/guide/best-practice#popup-window-blocked"
    );
    this.popup = popup;
    Object.setPrototypeOf(this, PopupCancelledError.prototype);
  }
}
const DEFAULT_AUTHORIZE_TIMEOUT_IN_SECONDS = 3e3;
const openPopup$1 = (url = "") => {
  const width = 375;
  const height = 660;
  const left = window.screenX + (window.innerWidth - width) / 2;
  const top = window.screenY + (window.innerHeight - height) / 2;
  return window.open(
    url,
    "joyid:authorize:popup",
    `left=${left},top=${top},width=${width},height=${height},resizable,scrollbars=yes,status=1`
  );
};
const runPopup$1 = (config) => new Promise((resolve, reject) => {
  if (isStandaloneBrowser()) {
    reject(new PopupNotSupportedError(config.popup));
  }
  let popupEventListener;
  let timeoutId;
  const popupTimer = setInterval(() => {
    if (config.popup && config.popup.closed) {
      clearInterval(popupTimer);
      clearTimeout(timeoutId);
      window.removeEventListener("message", popupEventListener, false);
      reject(new PopupCancelledError(config.popup));
    }
  }, 1e3);
  timeoutId = setTimeout(
    () => {
      clearInterval(popupTimer);
      reject(new PopupTimeoutError(config.popup));
      window.removeEventListener("message", popupEventListener, false);
    },
    (config.timeoutInSeconds || DEFAULT_AUTHORIZE_TIMEOUT_IN_SECONDS) * 1e3
  );
  popupEventListener = (e) => {
    var _a;
    const appURL = getConfig$1().joyidAppURL;
    if (e.origin !== appURL) {
      return;
    }
    if (!e.data || ((_a = e.data) == null ? void 0 : _a.type) !== config.type) {
      return;
    }
    clearTimeout(timeoutId);
    clearInterval(popupTimer);
    window.removeEventListener("message", popupEventListener, false);
    config.popup.close();
    resolve(e.data);
  };
  window.addEventListener("message", popupEventListener);
});
const buildJoyIDAuthURL$1 = (request, type) => buildJoyIDURL(request, type, "/auth");
const authWithRedirect$1 = (request) => {
  window.location.assign(buildJoyIDAuthURL$1(request, "redirect"));
};
const authWithPopup$1 = async (request, config) => {
  config = config || {};
  if (!config.popup) {
    config.popup = openPopup$1("");
    if (!config.popup) {
      throw new PopupNotSupportedError(config.popup);
    }
  }
  config.popup.location.href = buildJoyIDAuthURL$1(
    request,
    DappCommunicationType.Popup
  );
  const res = await runPopup$1({
    ...config,
    type: DappRequestType.Auth
  });
  if (res.error != null) {
    throw new Error(res.error);
  }
  return res.data;
};
const authCallback$1 = (uri) => getRedirectResponse(uri);
const authWithRedirect = authWithRedirect$1;
const authCallback = authCallback$1;
const authWithPopup = authWithPopup$1;
const buildJoyIDAuthURL = buildJoyIDAuthURL$1;
const getConfig = getConfig$1;
const initConfig = initConfig$1;
const buildJoyIDSignMessageURL$1 = (request, type) => buildJoyIDURL(request, type, "/sign-message");
const signMessageWithRedirect$1 = (request) => {
  window.location.assign(buildJoyIDSignMessageURL$1(request, "redirect"));
};
const signMessageWithPopup$1 = async (request, config) => {
  config = config || {};
  if (!config.popup) {
    config.popup = openPopup$1("");
    if (!config.popup) {
      throw new PopupNotSupportedError(config.popup);
    }
  }
  config.popup.location.href = buildJoyIDSignMessageURL$1(request, "popup");
  const res = await runPopup$1({
    ...config,
    type: DappRequestType.SignMessage
  });
  if (res.error != null) {
    throw new Error(res.error);
  }
  return res.data;
};
const signMessageCallback$1 = (uri) => getRedirectResponse(uri);
const signMessageCallback = signMessageCallback$1;
const signMessageWithPopup = signMessageWithPopup$1;
const signMessageWithRedirect = signMessageWithRedirect$1;
const buildJoyIDSignMessageURL = buildJoyIDSignMessageURL$1;
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var browserPonyfill = { exports: {} };
(function(module, exports) {
  var global2 = typeof self !== "undefined" ? self : commonjsGlobal;
  var __self__ = function() {
    function F() {
      this.fetch = false;
      this.DOMException = global2.DOMException;
    }
    F.prototype = global2;
    return new F();
  }();
  (function(self2) {
    (function(exports2) {
      var support = {
        searchParams: "URLSearchParams" in self2,
        iterable: "Symbol" in self2 && "iterator" in Symbol,
        blob: "FileReader" in self2 && "Blob" in self2 && function() {
          try {
            new Blob();
            return true;
          } catch (e) {
            return false;
          }
        }(),
        formData: "FormData" in self2,
        arrayBuffer: "ArrayBuffer" in self2
      };
      function isDataView(obj) {
        return obj && DataView.prototype.isPrototypeOf(obj);
      }
      if (support.arrayBuffer) {
        var viewClasses = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ];
        var isArrayBufferView = ArrayBuffer.isView || function(obj) {
          return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
        };
      }
      function normalizeName(name) {
        if (typeof name !== "string") {
          name = String(name);
        }
        if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
          throw new TypeError("Invalid character in header field name");
        }
        return name.toLowerCase();
      }
      function normalizeValue(value) {
        if (typeof value !== "string") {
          value = String(value);
        }
        return value;
      }
      function iteratorFor(items) {
        var iterator = {
          next: function() {
            var value = items.shift();
            return { done: value === void 0, value };
          }
        };
        if (support.iterable) {
          iterator[Symbol.iterator] = function() {
            return iterator;
          };
        }
        return iterator;
      }
      function Headers(headers) {
        this.map = {};
        if (headers instanceof Headers) {
          headers.forEach(function(value, name) {
            this.append(name, value);
          }, this);
        } else if (Array.isArray(headers)) {
          headers.forEach(function(header) {
            this.append(header[0], header[1]);
          }, this);
        } else if (headers) {
          Object.getOwnPropertyNames(headers).forEach(function(name) {
            this.append(name, headers[name]);
          }, this);
        }
      }
      Headers.prototype.append = function(name, value) {
        name = normalizeName(name);
        value = normalizeValue(value);
        var oldValue = this.map[name];
        this.map[name] = oldValue ? oldValue + ", " + value : value;
      };
      Headers.prototype["delete"] = function(name) {
        delete this.map[normalizeName(name)];
      };
      Headers.prototype.get = function(name) {
        name = normalizeName(name);
        return this.has(name) ? this.map[name] : null;
      };
      Headers.prototype.has = function(name) {
        return this.map.hasOwnProperty(normalizeName(name));
      };
      Headers.prototype.set = function(name, value) {
        this.map[normalizeName(name)] = normalizeValue(value);
      };
      Headers.prototype.forEach = function(callback, thisArg) {
        for (var name in this.map) {
          if (this.map.hasOwnProperty(name)) {
            callback.call(thisArg, this.map[name], name, this);
          }
        }
      };
      Headers.prototype.keys = function() {
        var items = [];
        this.forEach(function(value, name) {
          items.push(name);
        });
        return iteratorFor(items);
      };
      Headers.prototype.values = function() {
        var items = [];
        this.forEach(function(value) {
          items.push(value);
        });
        return iteratorFor(items);
      };
      Headers.prototype.entries = function() {
        var items = [];
        this.forEach(function(value, name) {
          items.push([name, value]);
        });
        return iteratorFor(items);
      };
      if (support.iterable) {
        Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
      }
      function consumed(body) {
        if (body.bodyUsed) {
          return Promise.reject(new TypeError("Already read"));
        }
        body.bodyUsed = true;
      }
      function fileReaderReady(reader) {
        return new Promise(function(resolve, reject) {
          reader.onload = function() {
            resolve(reader.result);
          };
          reader.onerror = function() {
            reject(reader.error);
          };
        });
      }
      function readBlobAsArrayBuffer(blob) {
        var reader = new FileReader();
        var promise = fileReaderReady(reader);
        reader.readAsArrayBuffer(blob);
        return promise;
      }
      function readBlobAsText(blob) {
        var reader = new FileReader();
        var promise = fileReaderReady(reader);
        reader.readAsText(blob);
        return promise;
      }
      function readArrayBufferAsText(buf) {
        var view = new Uint8Array(buf);
        var chars = new Array(view.length);
        for (var i = 0; i < view.length; i++) {
          chars[i] = String.fromCharCode(view[i]);
        }
        return chars.join("");
      }
      function bufferClone(buf) {
        if (buf.slice) {
          return buf.slice(0);
        } else {
          var view = new Uint8Array(buf.byteLength);
          view.set(new Uint8Array(buf));
          return view.buffer;
        }
      }
      function Body() {
        this.bodyUsed = false;
        this._initBody = function(body) {
          this._bodyInit = body;
          if (!body) {
            this._bodyText = "";
          } else if (typeof body === "string") {
            this._bodyText = body;
          } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
            this._bodyBlob = body;
          } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
            this._bodyFormData = body;
          } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
            this._bodyText = body.toString();
          } else if (support.arrayBuffer && support.blob && isDataView(body)) {
            this._bodyArrayBuffer = bufferClone(body.buffer);
            this._bodyInit = new Blob([this._bodyArrayBuffer]);
          } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
            this._bodyArrayBuffer = bufferClone(body);
          } else {
            this._bodyText = body = Object.prototype.toString.call(body);
          }
          if (!this.headers.get("content-type")) {
            if (typeof body === "string") {
              this.headers.set("content-type", "text/plain;charset=UTF-8");
            } else if (this._bodyBlob && this._bodyBlob.type) {
              this.headers.set("content-type", this._bodyBlob.type);
            } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
              this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
            }
          }
        };
        if (support.blob) {
          this.blob = function() {
            var rejected = consumed(this);
            if (rejected) {
              return rejected;
            }
            if (this._bodyBlob) {
              return Promise.resolve(this._bodyBlob);
            } else if (this._bodyArrayBuffer) {
              return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            } else if (this._bodyFormData) {
              throw new Error("could not read FormData body as blob");
            } else {
              return Promise.resolve(new Blob([this._bodyText]));
            }
          };
          this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
              return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
            } else {
              return this.blob().then(readBlobAsArrayBuffer);
            }
          };
        }
        this.text = function() {
          var rejected = consumed(this);
          if (rejected) {
            return rejected;
          }
          if (this._bodyBlob) {
            return readBlobAsText(this._bodyBlob);
          } else if (this._bodyArrayBuffer) {
            return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
          } else if (this._bodyFormData) {
            throw new Error("could not read FormData body as text");
          } else {
            return Promise.resolve(this._bodyText);
          }
        };
        if (support.formData) {
          this.formData = function() {
            return this.text().then(decode2);
          };
        }
        this.json = function() {
          return this.text().then(JSON.parse);
        };
        return this;
      }
      var methods = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function normalizeMethod(method) {
        var upcased = method.toUpperCase();
        return methods.indexOf(upcased) > -1 ? upcased : method;
      }
      function Request(input, options) {
        options = options || {};
        var body = options.body;
        if (input instanceof Request) {
          if (input.bodyUsed) {
            throw new TypeError("Already read");
          }
          this.url = input.url;
          this.credentials = input.credentials;
          if (!options.headers) {
            this.headers = new Headers(input.headers);
          }
          this.method = input.method;
          this.mode = input.mode;
          this.signal = input.signal;
          if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
          }
        } else {
          this.url = String(input);
        }
        this.credentials = options.credentials || this.credentials || "same-origin";
        if (options.headers || !this.headers) {
          this.headers = new Headers(options.headers);
        }
        this.method = normalizeMethod(options.method || this.method || "GET");
        this.mode = options.mode || this.mode || null;
        this.signal = options.signal || this.signal;
        this.referrer = null;
        if ((this.method === "GET" || this.method === "HEAD") && body) {
          throw new TypeError("Body not allowed for GET or HEAD requests");
        }
        this._initBody(body);
      }
      Request.prototype.clone = function() {
        return new Request(this, { body: this._bodyInit });
      };
      function decode2(body) {
        var form = new FormData();
        body.trim().split("&").forEach(function(bytes) {
          if (bytes) {
            var split = bytes.split("=");
            var name = split.shift().replace(/\+/g, " ");
            var value = split.join("=").replace(/\+/g, " ");
            form.append(decodeURIComponent(name), decodeURIComponent(value));
          }
        });
        return form;
      }
      function parseHeaders(rawHeaders) {
        var headers = new Headers();
        var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
        preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
          var parts = line.split(":");
          var key = parts.shift().trim();
          if (key) {
            var value = parts.join(":").trim();
            headers.append(key, value);
          }
        });
        return headers;
      }
      Body.call(Request.prototype);
      function Response(bodyInit, options) {
        if (!options) {
          options = {};
        }
        this.type = "default";
        this.status = options.status === void 0 ? 200 : options.status;
        this.ok = this.status >= 200 && this.status < 300;
        this.statusText = "statusText" in options ? options.statusText : "OK";
        this.headers = new Headers(options.headers);
        this.url = options.url || "";
        this._initBody(bodyInit);
      }
      Body.call(Response.prototype);
      Response.prototype.clone = function() {
        return new Response(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new Headers(this.headers),
          url: this.url
        });
      };
      Response.error = function() {
        var response = new Response(null, { status: 0, statusText: "" });
        response.type = "error";
        return response;
      };
      var redirectStatuses = [301, 302, 303, 307, 308];
      Response.redirect = function(url, status) {
        if (redirectStatuses.indexOf(status) === -1) {
          throw new RangeError("Invalid status code");
        }
        return new Response(null, { status, headers: { location: url } });
      };
      exports2.DOMException = self2.DOMException;
      try {
        new exports2.DOMException();
      } catch (err) {
        exports2.DOMException = function(message, name) {
          this.message = message;
          this.name = name;
          var error = Error(message);
          this.stack = error.stack;
        };
        exports2.DOMException.prototype = Object.create(Error.prototype);
        exports2.DOMException.prototype.constructor = exports2.DOMException;
      }
      function fetch2(input, init) {
        return new Promise(function(resolve, reject) {
          var request = new Request(input, init);
          if (request.signal && request.signal.aborted) {
            return reject(new exports2.DOMException("Aborted", "AbortError"));
          }
          var xhr = new XMLHttpRequest();
          function abortXhr() {
            xhr.abort();
          }
          xhr.onload = function() {
            var options = {
              status: xhr.status,
              statusText: xhr.statusText,
              headers: parseHeaders(xhr.getAllResponseHeaders() || "")
            };
            options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
            var body = "response" in xhr ? xhr.response : xhr.responseText;
            resolve(new Response(body, options));
          };
          xhr.onerror = function() {
            reject(new TypeError("Network request failed"));
          };
          xhr.ontimeout = function() {
            reject(new TypeError("Network request failed"));
          };
          xhr.onabort = function() {
            reject(new exports2.DOMException("Aborted", "AbortError"));
          };
          xhr.open(request.method, request.url, true);
          if (request.credentials === "include") {
            xhr.withCredentials = true;
          } else if (request.credentials === "omit") {
            xhr.withCredentials = false;
          }
          if ("responseType" in xhr && support.blob) {
            xhr.responseType = "blob";
          }
          request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
          });
          if (request.signal) {
            request.signal.addEventListener("abort", abortXhr);
            xhr.onreadystatechange = function() {
              if (xhr.readyState === 4) {
                request.signal.removeEventListener("abort", abortXhr);
              }
            };
          }
          xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
        });
      }
      fetch2.polyfill = true;
      if (!self2.fetch) {
        self2.fetch = fetch2;
        self2.Headers = Headers;
        self2.Request = Request;
        self2.Response = Response;
      }
      exports2.Headers = Headers;
      exports2.Request = Request;
      exports2.Response = Response;
      exports2.fetch = fetch2;
      Object.defineProperty(exports2, "__esModule", { value: true });
      return exports2;
    })({});
  })(__self__);
  __self__.fetch.ponyfill = true;
  delete __self__.fetch.polyfill;
  var ctx = __self__;
  exports = ctx.fetch;
  exports.default = ctx.fetch;
  exports.fetch = ctx.fetch;
  exports.Headers = ctx.Headers;
  exports.Request = ctx.Request;
  exports.Response = ctx.Response;
  module.exports = exports;
})(browserPonyfill, browserPonyfill.exports);
var browserPonyfillExports = browserPonyfill.exports;
const fetch = /* @__PURE__ */ getDefaultExportFromCjs(browserPonyfillExports);
var SigningAlg = /* @__PURE__ */ ((SigningAlg2) => {
  SigningAlg2[SigningAlg2["RS256"] = -257] = "RS256";
  SigningAlg2[SigningAlg2["ES256"] = -7] = "ES256";
  return SigningAlg2;
})(SigningAlg || {});
const isNodeJs = () => typeof process !== "undefined" && process.versions != null && process.versions.node != null;
const getSubtleCrypto = async () => {
  var _a, _b, _c;
  if (typeof window !== "undefined" && ((_a = window.crypto) == null ? void 0 : _a.subtle)) {
    return window.crypto.subtle;
  }
  if (typeof globalThis !== "undefined" && ((_b = globalThis.crypto) == null ? void 0 : _b.subtle)) {
    return globalThis.crypto.subtle;
  }
  if (isNodeJs()) {
    const nodeCrypto = typeof require === "function" ? require("crypto") : await import("crypto");
    if ((_c = nodeCrypto == null ? void 0 : nodeCrypto.webcrypto) == null ? void 0 : _c.subtle) {
      return nodeCrypto.webcrypto.subtle;
    }
  }
  throw new Error("SubtleCrypto is not available in this environment.");
};
const ensureChallenge = (challenge, clientData) => {
  try {
    const clienDataJSON = hexToString(bufferToHex(clientData));
    const clientDataObj = JSON.parse(clienDataJSON);
    return clientDataObj.challenge === bufferToBase64URLString(utf8StringToBuffer(challenge));
  } catch (error) {
    return false;
  }
};
const verifySessionKeySignature = async (message, signature, pubkey) => {
  const subtle = await getSubtleCrypto();
  try {
    const algoName = "RSASSA-PKCS1-v1_5";
    const pk = hexToArrayBuffer(pubkey);
    const msg = base64URLStringToBuffer(message);
    const sig = base64URLStringToBuffer(signature);
    const e = new Uint8Array(pk.slice(0, 3)).reverse();
    const n = new Uint8Array(pk.slice(4)).reverse();
    const jwkPubkey = {
      alg: "RS256",
      ext: true,
      key_ops: ["verify"],
      kty: "RSA",
      e: bufferToBase64URLString(e),
      n: bufferToBase64URLString(n)
    };
    const key = await subtle.importKey(
      "jwk",
      jwkPubkey,
      {
        name: algoName,
        hash: "SHA-256"
      },
      false,
      ["verify"]
    );
    const res = await subtle.verify(algoName, key, sig, msg);
    return res;
  } catch (error) {
    console.error(error);
    return false;
  }
};
const verifyNativeKeySignature = async ({
  message,
  signature,
  pubkey,
  challenge,
  alg
}) => {
  const subtle = await getSubtleCrypto();
  try {
    const pk = hexToArrayBuffer(`${pubkey}`);
    const msg = base64URLStringToBuffer(message);
    const sig = base64URLStringToBuffer(signature);
    const authData = msg.slice(0, 37);
    const clientData = msg.slice(37);
    if (!ensureChallenge(challenge, clientData)) {
      return false;
    }
    const clientDataHash = await subtle.digest("SHA-256", clientData);
    const signatureBase = appendBuffer(authData, clientDataHash);
    const isR1 = alg === SigningAlg.ES256;
    const jwkPubkey = isR1 ? {
      kty: "EC",
      crv: "P-256",
      x: bufferToBase64URLString(pk.slice(0, 32)),
      y: bufferToBase64URLString(pk.slice(32))
    } : {
      alg: "RS256",
      ext: true,
      key_ops: ["verify"],
      kty: "RSA",
      e: bufferToBase64URLString(new Uint8Array(pk.slice(0, 3)).reverse()),
      n: bufferToBase64URLString(new Uint8Array(pk.slice(4)).reverse())
    };
    const algo = isR1 ? {
      name: "ECDSA",
      namedCurve: "P-256",
      hash: { name: "SHA-256" }
    } : {
      name: "RSASSA-PKCS1-v1_5",
      hash: "SHA-256"
    };
    const key = await subtle.importKey("jwk", jwkPubkey, algo, false, [
      "verify"
    ]);
    const res = await subtle.verify(
      algo,
      key,
      alg === SigningAlg.RS256 ? sig : derToIEEE(sig),
      signatureBase
    );
    return res;
  } catch (error) {
    console.error(error);
    return false;
  }
};
const verifySignature = async (data) => {
  const { message, signature, pubkey, keyType } = data;
  if (keyType === "main_key" || keyType === "sub_key") {
    return verifyNativeKeySignature(data);
  }
  return verifySessionKeySignature(message, signature, pubkey);
};
const verifyCredential = async (pubkey, address, keyType, alg) => {
  const serverURL = getConfig$1().joyidServerURL;
  try {
    const result = await fetch(
      `${serverURL}/credentials/${address}`,
      {
        method: "GET"
      }
    ).then((res) => res.json());
    return result.credentials.some((c) => {
      const pk = alg === SigningAlg.RS256 || keyType === "main_session_key" || keyType === "sub_session_key" ? c.public_key : c.public_key.slice(2);
      return c.ckb_address === address && pk === pubkey;
    });
  } catch (error) {
    console.error(error);
    return false;
  }
};
const openPopup = openPopup$1;
const runPopup = runPopup$1;
export {
  authCallback,
  authWithPopup,
  authWithRedirect,
  buildJoyIDAuthURL,
  buildJoyIDSignMessageURL,
  ensureChallenge,
  getConfig,
  initConfig,
  openPopup,
  runPopup,
  signMessageCallback,
  signMessageWithPopup,
  signMessageWithRedirect,
  verifyCredential,
  verifyNativeKeySignature,
  verifySessionKeySignature,
  verifySignature
};
